export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';
